import { Grid, Tab, Tabs, styled } from "@mui/material";

import { ADVANCED_TRADE_BUY_SELL_TABS } from "pages/BasicTrade/components/constants";
import React from "react";
import { useSearchParams } from "react-router-dom";

function MarketTabs() {
  const [searchParams, setSearchParams] = useSearchParams();
  const marketTab =
    +searchParams.get("marketTab") || ADVANCED_TRADE_BUY_SELL_TABS.buyFromUs;

  const handleChangeTab = (_, tab) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      marketTab: tab,
    });
  };

  return (
    <Grid item xs={12}>
      <TabsStyle value={marketTab} onChange={handleChangeTab}>
        <Tab
          value={ADVANCED_TRADE_BUY_SELL_TABS.buyFromUs}
          label="قیمت خرید از ما‍"
        />

        <Tab
          value={ADVANCED_TRADE_BUY_SELL_TABS.sellToUs}
          label="قیمت فروش به ما"
        />
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default MarketTabs;
